import { createRouter, createWebHistory } from "vue-router";
import { getToken } from "@/utils/auth";
import Application from "./dataClass/index.js";

const routes = [
  {
    path: "/login",
    name: "Login",
    component: () => import("@/views/login/login.vue"),
  },
  {
    path: "/",
    component: () => import("@/views/platform/home"),
    redirect: "/entrance",
    children: [
      {
        path: "/about",
        name: "About",
        component: () => import("@/views/About.vue"),
        children: [
          {
            path: "/index",
            name: "Index",
            component: () => import("@/views/platform/index.vue"),
          },
          {
            path: "/indexDetail",
            name: "indexDetail",
            component: () => import("@/views/platform/indexDetail.vue"),
          },
        ],
      },

      {
        path: "/portal:pathMatch(.*)",
        name: "portal",
        component: () => import("@/views/About.vue"),
      },
    ],
  },
  {
    path: "/",
    component: () => import("@/views/platform/home"),
    children: [
      {
        path: "/userCenter",
        name: "userCenter",
        component: () => import("@/views/About.vue"),
        children: [...Application],
      },
    ],
  },

  {
    name: "401",
    path: "/401",
    component: () => import("@/views/Error/401.vue"),
  },
  {
    name: "404",
    path: "/404",
    component: () => import("@/views/Error/404.vue"),
  },
  {
    name: "entrance",
    path: "/entrance",
    component: () => import("@/views/entrance/index.vue"),
  },
  {
    name: "SmartPlant",
    path: "/smartPlant",
    component: () => import("@/views/smartPlant/index.vue"),
    meta: {
      title: "智慧厂站",
      keepAlive: true,
      frameSrc:
        process.env.NODE_ENV === "production"
          ? process.env.VUE_APP_PLANT_URL + "/urinePC"
          : process.env.VUE_APP_PLANT_URL,
    },
  },
  // {
  //   path: "/:catchAll(.*)",
  //   redirect: "/404",
  // },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});
import store from "../store";
router.beforeEach(async (to, from, next) => {
  console.log("to, from, next", to, from);

  if (getToken()) {
    if (to.path === "/login") {
      next({ path: "/" });
    } else {
      if (store.getters.roles.length === 0) {
        //判断当前用户是否已拉取完user_info信息
        await store
          .dispatch("userInfo/GetInfo")
          .then(async () => {
            next();
          })
          .catch(async (err) => {
            await store
              .dispatch("userInfo/LogOut")
              .then(() => {
                next({ path: "/login" });
              })
              .catch(() => {
                next({ path: "/login" });
              });
          });
      } else {
        next();
      }
    }
  } else {
    // 没有token
    console.log("没有token");
    if (to.path !== "/login") {
      next({ path: "/login" });
    } else {
      next();
    }

    // if (whiteList.indexOf(to.path) !== -1) {
    //     // 在免登录白名单，直接进入
    //     next()
    // } else {
    //     next(`/login?redirect=${to.fullPath}`) // 否则全部重定向到登录页
    // }
  }
});
/* 路由异常错误处理，尝试解析一个异步组件时发生错误，重新渲染目标页面 */
router.onError((error) => {
  const pattern = /Loading chunk (\d)+ failed/g;
  const isChunkLoadFailed = error.message.match(pattern);
  const targetPath = router.history.pending.fullPath;
  if (isChunkLoadFailed) {
    router.replace(targetPath);
  }
});

export default router;
